export class PageForm {
  fromDate: string;
  toDate: string;
  hqName: string;
  vendorName: string;
  vroongOrderNo: string;
  applicantOrderNumber: string;
  applicantDeliveryNumber: string;
  page: number;
  size: number;


  constructor() {

  }
}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/calculate/form.model.ts